/* eslint no-shadow: ["error", { "allow": ["state"] }] */

import OverviewReportService from '../../services/OverviewReportService';
import ErrorHandlerHelpers from '../../mixins/ErrorHandlerHelpers';

const SET_OVERVIEW_REPORT = 'SET_OVERVIEW_REPORT';
const CLEAR_OVERVIEW_REPORT = 'CLEAR_OVERVIEW_REPORT';

const state = {
  overviewReport: null,
};

const mutations = {
  [SET_OVERVIEW_REPORT](state, overviewReport) {
    state.overviewReport = overviewReport;
  },
  [CLEAR_OVERVIEW_REPORT](state) {
    state.overviewReport = null;
  },
};

const actions = ({
  loadOverviewReport({ commit }, activeSiteId) {
    return OverviewReportService.getOverviewReport(activeSiteId)
      .then((x) => x.data)
      .then((overviewReportData) => {
        commit(SET_OVERVIEW_REPORT, overviewReportData);
      }).catch((error) => ErrorHandlerHelpers.handleServiceError(error));
  },
  clearOverviewReport({ commit }) {
    commit(CLEAR_OVERVIEW_REPORT);
  },
});

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
